<div class="error-page">
    <div class="error-indicator"></div>
    <div class="error-content">
        <h1>ACCESS DENIED</h1>
        <p class="text"></p>
    </div>
</div>